import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import { ReduxInput, ReduxNumberInput } from 'components/FormElements'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// constants
import { Modals } from 'constants/modals'
import { FieldType, IField } from 'types/graphql'

const Wrapper = styled.div<{ withModal: boolean }>`
  ${({ withModal }) =>
    withModal &&
    css`
      > div {
        pointer-events: none;
      }

      &:hover {
        *::before {
          border-bottom: 2px solid black;
        }
      }
    `}
`

interface Props {
  name: string
  field: IField
  disabled?: boolean
}

const TextField: React.FC<Props> = ({ name, field, disabled }) => {
  const { showModal } = useShowModal({ modalType: Modals.TEXT_FIELD_CONTENT })

  const isText = field?.fieldType === FieldType.Text

  const onFieldClick = () => {
    if (!disabled && field.settings?.manualSave) {
      showModal({ field, name })
    }
  }

  return (
    <Wrapper
      onClick={onFieldClick}
      withModal={!!field.settings?.manualSave}
      data-testid='risk-field-value'
      data-entity-id={field.id}>
      {isText ? (
        <ReduxInput debounced disabled={disabled} multiline label={field.label} name={name} required={field.required} />
      ) : (
        <ReduxNumberInput debounced disabled={disabled} field={field} name={name} required={field.required} />
      )}
    </Wrapper>
  )
}

export default TextField
